import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
interface PricingGridProps {
  selectedPack: number;
  setSelectedPack: (pack: number) => void;
  packLinks: string[];
}
export function PricingGrid({
  selectedPack,
  setSelectedPack,
  packLinks
}: PricingGridProps) {
  return <div className="w-full" data-id="element-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 items-start mb-6" data-id="element-5">
        {/* Pack 0: Mega Pack */}
        <div onClick={() => setSelectedPack(0)} className={`relative bg-[#1a1a1a] border rounded-[10px] overflow-hidden transition-all duration-200 cursor-pointer ${selectedPack === 0 ? 'border-[#f5a623] shadow-[0_0_40px_rgba(245,166,35,0.15)] -translate-y-1' : 'border-[#2a2a2a] hover:border-[#f5a623]/40 hover:-translate-y-1'}`} data-id="element-6">
          <div className="p-8 md:p-7" data-id="element-7">
            <div className="font-['Barlow_Condensed'] text-[22px] font-bold text-[#f5f0e8] uppercase tracking-[0.05em] mb-1.5 flex items-center gap-2" data-id="element-8">
              <span data-id="element-9">📦</span> MEGA PACK MAESTRO CERRAJERO
            </div>
            <div className="text-[14px] text-[#888888] mb-6" data-id="element-10">
              Ideal para empezar desde cero
            </div>

            <div className="text-[18px] text-[#888888] line-through mb-1" data-id="element-11">
              ARS $39.990
            </div>
            <div className="font-['Bebas_Neue'] text-[60px] text-[#f5f0e8] leading-none tracking-[0.02em] mb-1.5" data-id="element-12">
              <span className="text-[32px] align-top mt-2.5 inline-block text-[#f5a623] mr-1" data-id="element-13">
                $
              </span>
              19.990
            </div>
            <div className="text-[14px] text-[#888888] mb-6" data-id="element-14">
              Pesos argentinos · Pago único
            </div>

            <ul className="list-none mb-7 space-y-0" data-id="element-15">
              {['Módulo completo cerrajería de puertas', 'Técnicas de lockpicking con ganzúas', 'Manuales profesionales en PDF (+100 págs)', 'Videos paso a paso (+2hs de contenido)', 'Bonus #1: Maletín Inteligente', 'Bonus #2: Método Ganzúa PRO', 'Bonus #3: Biblia del Cerrajero', 'Acceso de por vida'].map((feature, idx) => <li key={idx} className="py-[9px] border-b border-[#2a2a2a] flex items-center gap-2.5 text-[14px] text-[#ccc] last:border-b-0" data-id="element-16">
                  <span className="text-[#22c55e] font-bold flex-shrink-0" data-id="element-17">
                    ✓
                  </span>
                  {feature}
                </li>)}
            </ul>

            <a href={packLinks[0]} className={`block w-full font-['Barlow_Condensed'] font-extrabold text-[18px] tracking-[0.06em] uppercase py-4 rounded-md text-center transition-all duration-200 ${selectedPack === 0 ? 'bg-[#f5a623] text-[#0a0a0a] shadow-[0_6px_24px_rgba(245,166,35,0.3)] hover:bg-[#ffc94d] hover:-translate-y-px' : 'bg-transparent border-2 border-[#f5a623] text-[#f5a623] hover:bg-[rgba(245,166,35,0.08)]'}`} onClick={e => {
            if (selectedPack !== 0) {
              e.preventDefault();
              setSelectedPack(0);
            }
          }} data-id="element-18">
              → Acceder por $19.990
            </a>
          </div>
        </div>

        {/* Pack 1: Mega Pack + Auto */}
        <div onClick={() => setSelectedPack(1)} className={`relative bg-[#1a1a1a] border rounded-[10px] overflow-hidden transition-all duration-200 cursor-pointer ${selectedPack === 1 ? 'border-[#f5a623] shadow-[0_0_40px_rgba(245,166,35,0.15)] -translate-y-1' : 'border-[#2a2a2a] hover:border-[#f5a623]/40 hover:-translate-y-1'}`} data-id="element-19">
          <div className="bg-[#f5a623] text-[#0a0a0a] font-['Barlow_Condensed'] font-extrabold text-[13px] uppercase tracking-[0.1em] text-center py-2" data-id="element-20">
            ⭐ Más elegido — Mayor potencial de ingresos
          </div>
          <div className="p-8 md:p-7" data-id="element-21">
            <div className="font-['Barlow_Condensed'] text-[22px] font-bold text-[#f5f0e8] uppercase tracking-[0.05em] mb-1.5 flex items-center gap-2" data-id="element-22">
              <span data-id="element-23">🚀</span> Pack + Cerrajería Automotriz
            </div>
            <div className="text-[14px] text-[#888888] mb-6" data-id="element-24">
              Trabajos más avanzados y mejor pagos
            </div>

            <div className="text-[18px] text-[#888888] line-through mb-1" data-id="element-25">
              ARS $49.990
            </div>
            <div className="font-['Bebas_Neue'] text-[60px] text-[#f5f0e8] leading-none tracking-[0.02em] mb-1.5" data-id="element-26">
              <span className="text-[32px] align-top mt-2.5 inline-block text-[#f5a623] mr-1" data-id="element-27">
                $
              </span>
              29.990
            </div>
            <div className="text-[14px] text-[#888888] mb-6" data-id="element-28">
              Pesos argentinos · Pago único
            </div>

            <ul className="list-none mb-7 space-y-0" data-id="element-29">
              {['Todo lo incluido en el pack anterior', 'Módulo completo cerrajería automotriz', 'Clonación de llaves y transponders', 'Programación de sistemas electrónicos', 'Llaves por código y por copia', 'Los trabajos mejor pagos del mercado', 'Por solo $10.000 más que el pack base'].map((feature, idx) => <li key={idx} className="py-[9px] border-b border-[#2a2a2a] flex items-center gap-2.5 text-[14px] text-[#ccc] last:border-b-0" data-id="element-30">
                  <span className="text-[#22c55e] font-bold flex-shrink-0" data-id="element-31">
                    ✓
                  </span>
                  {feature}
                </li>)}
            </ul>

            <a href={packLinks[1]} className={`block w-full font-['Barlow_Condensed'] font-extrabold text-[18px] tracking-[0.06em] uppercase py-4 rounded-md text-center transition-all duration-200 ${selectedPack === 1 ? 'bg-[#f5a623] text-[#0a0a0a] shadow-[0_6px_24px_rgba(245,166,35,0.3)] hover:bg-[#ffc94d] hover:-translate-y-px btn-primary' : 'bg-transparent border-2 border-[#f5a623] text-[#f5a623] hover:bg-[rgba(245,166,35,0.08)]'}`} onClick={e => {
            if (selectedPack !== 1) {
              e.preventDefault();
              setSelectedPack(1);
            }
          }} data-id="element-32">
              → Acceder por $29.990
            </a>
          </div>
        </div>
      </div>

      <p className="text-center mt-6 text-[13px] text-[#888888] flex items-center justify-center gap-1.5" data-id="element-33">
        <LockIcon className="w-3.5 h-3.5" data-id="element-34" /> Pago seguro con Mercado Pago ·
        Tarjeta · Transferencia · El material llega a tu email al instante
      </p>
    </div>;
}